/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SocialPolicy } from './SocialPolicy';
import {
    SocialPolicyFromJSON,
    SocialPolicyFromJSONTyped,
    SocialPolicyToJSON,
    SocialPolicyToJSONTyped,
} from './SocialPolicy';
import type { EventValidator } from './EventValidator';
import {
    EventValidatorFromJSON,
    EventValidatorFromJSONTyped,
    EventValidatorToJSON,
    EventValidatorToJSONTyped,
} from './EventValidator';
import type { RewardAutoSettingsMap } from './RewardAutoSettingsMap';
import {
    RewardAutoSettingsMapFromJSON,
    RewardAutoSettingsMapFromJSONTyped,
    RewardAutoSettingsMapToJSON,
    RewardAutoSettingsMapToJSONTyped,
} from './RewardAutoSettingsMap';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { MilestoneCheckpoint } from './MilestoneCheckpoint';
import {
    MilestoneCheckpointFromJSON,
    MilestoneCheckpointFromJSONTyped,
    MilestoneCheckpointToJSON,
    MilestoneCheckpointToJSONTyped,
} from './MilestoneCheckpoint';
import type { Prerequisite } from './Prerequisite';
import {
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    PrerequisiteToJSONTyped,
} from './Prerequisite';

/**
 * Frozen copy of an ObjectiveTemplate on an activation — all LogicModule fields with resolved targetAmount
 * @export
 * @interface SnapshotObjective
 */
export interface SnapshotObjective {
    /**
     * The EarnConfig this assignment scores. When present it owns the action definition.
     * @type {string}
     * @memberof SnapshotObjective
     */
    earnConfigId?: string;
    /**
     * EarnConfig version pinned at snapshot time, so a later catalog edit cannot change what a running campaign scores.
     * @type {number}
     * @memberof SnapshotObjective
     */
    earnConfigVersion?: number;
    /**
     * 
     * @type {SocialPolicy}
     * @memberof SnapshotObjective
     */
    socialPolicy?: SocialPolicy;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    objectiveTemplateId?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    logicType?: string;
    /**
     * 
     * @type {number}
     * @memberof SnapshotObjective
     */
    targetAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SnapshotObjective
     */
    sessionAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    sessionCadence?: string;
    /**
     * 
     * @type {EventValidator}
     * @memberof SnapshotObjective
     */
    triggerEvent?: EventValidator;
    /**
     * 
     * @type {EventValidator}
     * @memberof SnapshotObjective
     */
    resetEvent?: EventValidator;
    /**
     * 
     * @type {EventValidator}
     * @memberof SnapshotObjective
     */
    finishEvent?: EventValidator;
    /**
     * 
     * @type {Array<string>}
     * @memberof SnapshotObjective
     */
    sources?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    subtype?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    gameId?: string;
    /**
     * 
     * @type {Array<MilestoneCheckpoint>}
     * @memberof SnapshotObjective
     */
    checkpoints?: Array<MilestoneCheckpoint>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SnapshotObjective
     */
    rewardConfigIds?: Array<string>;
    /**
     * Catalog-item grants (reward-catalog Option B) snapshot from the objective template.
     * @type {Array<RewardGrant>}
     * @memberof SnapshotObjective
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {RewardAutoSettingsMap}
     * @memberof SnapshotObjective
     */
    rewardAutoSettings?: RewardAutoSettingsMap;
    /**
     * 
     * @type {number}
     * @memberof SnapshotObjective
     */
    rewardPer?: number;
    /**
     * 
     * @type {number}
     * @memberof SnapshotObjective
     */
    displayDivider?: number;
    /**
     * 
     * @type {number}
     * @memberof SnapshotObjective
     */
    displayPriority?: number;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    photoExampleAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    photoInstructions?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    codeInstructions?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    scanInstructions?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapshotObjective
     */
    validQrPattern?: string;
    /**
     * Display-only short tag rendered on the mission row (e.g. "Avalon · Colosseum" for a Photo Op, "#FullThrottleChallenge" for a Social row). Frontends render verbatim, no parsing.
     * @type {string}
     * @memberof SnapshotObjective
     */
    poiTag?: string;
    /**
     * 
     * @type {Array<Prerequisite>}
     * @memberof SnapshotObjective
     */
    prerequisites?: Array<Prerequisite>;
}

/**
 * Check if a given object implements the SnapshotObjective interface.
 */
export function instanceOfSnapshotObjective(value: object): value is SnapshotObjective {
    return true;
}

export function SnapshotObjectiveFromJSON(json: any): SnapshotObjective {
    return SnapshotObjectiveFromJSONTyped(json, false);
}

export function SnapshotObjectiveFromJSONTyped(json: any, ignoreDiscriminator: boolean): SnapshotObjective {
    if (json == null) {
        return json;
    }
    return {
        
        'earnConfigId': json['earnConfigId'] == null ? undefined : json['earnConfigId'],
        'earnConfigVersion': json['earnConfigVersion'] == null ? undefined : json['earnConfigVersion'],
        'socialPolicy': json['socialPolicy'] == null ? undefined : SocialPolicyFromJSON(json['socialPolicy']),
        'objectiveTemplateId': json['objectiveTemplateId'] == null ? undefined : json['objectiveTemplateId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'logicType': json['logicType'] == null ? undefined : json['logicType'],
        'targetAmount': json['targetAmount'] == null ? undefined : json['targetAmount'],
        'sessionAmount': json['sessionAmount'] == null ? undefined : json['sessionAmount'],
        'sessionCadence': json['sessionCadence'] == null ? undefined : json['sessionCadence'],
        'triggerEvent': json['triggerEvent'] == null ? undefined : EventValidatorFromJSON(json['triggerEvent']),
        'resetEvent': json['resetEvent'] == null ? undefined : EventValidatorFromJSON(json['resetEvent']),
        'finishEvent': json['finishEvent'] == null ? undefined : EventValidatorFromJSON(json['finishEvent']),
        'sources': json['sources'] == null ? undefined : json['sources'],
        'subtype': json['subtype'] == null ? undefined : json['subtype'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'checkpoints': json['checkpoints'] == null ? undefined : ((json['checkpoints'] as Array<any>).map(MilestoneCheckpointFromJSON)),
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'rewardAutoSettings': json['rewardAutoSettings'] == null ? undefined : RewardAutoSettingsMapFromJSON(json['rewardAutoSettings']),
        'rewardPer': json['rewardPer'] == null ? undefined : json['rewardPer'],
        'displayDivider': json['displayDivider'] == null ? undefined : json['displayDivider'],
        'displayPriority': json['displayPriority'] == null ? undefined : json['displayPriority'],
        'url': json['url'] == null ? undefined : json['url'],
        'photoExampleAssetId': json['photoExampleAssetId'] == null ? undefined : json['photoExampleAssetId'],
        'photoInstructions': json['photoInstructions'] == null ? undefined : json['photoInstructions'],
        'codeInstructions': json['codeInstructions'] == null ? undefined : json['codeInstructions'],
        'scanInstructions': json['scanInstructions'] == null ? undefined : json['scanInstructions'],
        'validQrPattern': json['validQrPattern'] == null ? undefined : json['validQrPattern'],
        'poiTag': json['poiTag'] == null ? undefined : json['poiTag'],
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
    };
}

export function SnapshotObjectiveToJSON(json: any): SnapshotObjective {
    return SnapshotObjectiveToJSONTyped(json, false);
}

export function SnapshotObjectiveToJSONTyped(value?: SnapshotObjective | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'earnConfigId': value['earnConfigId'],
        'earnConfigVersion': value['earnConfigVersion'],
        'socialPolicy': SocialPolicyToJSON(value['socialPolicy']),
        'objectiveTemplateId': value['objectiveTemplateId'],
        'name': value['name'],
        'description': value['description'],
        'category': value['category'],
        'logicType': value['logicType'],
        'targetAmount': value['targetAmount'],
        'sessionAmount': value['sessionAmount'],
        'sessionCadence': value['sessionCadence'],
        'triggerEvent': EventValidatorToJSON(value['triggerEvent']),
        'resetEvent': EventValidatorToJSON(value['resetEvent']),
        'finishEvent': EventValidatorToJSON(value['finishEvent']),
        'sources': value['sources'],
        'subtype': value['subtype'],
        'gameId': value['gameId'],
        'checkpoints': value['checkpoints'] == null ? undefined : ((value['checkpoints'] as Array<any>).map(MilestoneCheckpointToJSON)),
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'rewardAutoSettings': RewardAutoSettingsMapToJSON(value['rewardAutoSettings']),
        'rewardPer': value['rewardPer'],
        'displayDivider': value['displayDivider'],
        'displayPriority': value['displayPriority'],
        'url': value['url'],
        'photoExampleAssetId': value['photoExampleAssetId'],
        'photoInstructions': value['photoInstructions'],
        'codeInstructions': value['codeInstructions'],
        'scanInstructions': value['scanInstructions'],
        'validQrPattern': value['validQrPattern'],
        'poiTag': value['poiTag'],
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteToJSON)),
    };
}

